import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    TabRoot: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "space-between",
      paddingBottom: "4px",
      "& .MuiAppBar-root": {
        width: "auto",
      },
      "& .MuiTabs-indicator": {
        background: "#3D899F",
      },
      "& #tab-area": {
        fontWeight: "900!important",
      },
    },
    AppBar: {
      borderRadius: "10px 10px 0 0",
      overflow: "hidden",
      // background: "transparent",
    },
    tabButton: {
      padding: "6px 10px",
      Width: "30px",
      background: "gray",
      // textTransform: "inherit",
      "&.Mui-selected": {
        background: "#ffffff",
        color: "#3D899F",
      },
      "&.Mui-disabled": {
        background: "rgba(169, 169, 169)!important",
        opacity: "1!important",
      },
    },

    multiColumnPie: {
      display: "grid",
      gridColumn: "3",
      gridTemplateColumns: "1fr 1fr 1fr",
      gridGap: "2rem",
      margin: "10px",
      width: "50%",
      paddingTop: "0",
    },
    multiColumnBar: {
      display: "grid",
      gridColumn: "2",
      gridTemplateColumns: "1fr 1fr",
      gridGap: "2rem",
      marginLeft: "10px",
      marginTop: "20px",
      paddingTop: "0",
    },

    pageWrapper: {
      width: "100%",
      margin: "0px",
    },

    itemGrid: {
      display: "inline-grid",
      margin: "0",
      gridTemplateColumns: "280px 280px",
      gridTemplateRows: "280px 1fr",
    },
    item1: {
      gridColumn: "1 / 3",
      gridRow: "3 / 4",
    },
    root: {
      borderBottom: "1px solid #CFCFCF",

      "& dl": {
        paddingLeft: "10px",
        paddingRight: "10px",
      },
      "& dd": {
        margin: "0",
        paddingTop: "5px",
      },
      "& .MuiOutlinedInput-input": {
        height: "30px",
        padding: "0",
        paddingLeft: "5px",
        paddingRight: "5px",
      },
    },
    row: {
      display: "flex",
      width: "100%",
      flexWrap: "wrap",
      padding: "10px 10px 10px 10px",
      //borderTop: "1px solid #CFCFCF",
    },
    advancedButton: {
      "& button": {
        width: "140px",
        padding: "5px 0",
      },
    },
    searchControlSelect: {
      width: "140px",
      "& .MuiInputBase-root": {
        height: "30px",
      },
    },
    buttonArea: {
      padding: "32px 0 0 10px",
      "& .MuiButton-root": {
        padding: "6px 12px",
      },
    },
    buttonArea02: {
      padding: "32px 0 0 10px",
      position: "absolute",
      right: "22px",
      "& .MuiButton-root": {
        padding: "6px 12px",
      },
    },
    buttonCondition: {
      marginTop: "6px",
      height: "30px",
      "& .MuiButton-label": {
        paddingTop: "2px",
      },
    },
    datePickerContainer: {
      position: "relative",
      display: "flex",
      marginTop: "-4px!important",
      justifyContent: "space-between",
    },
    datePickerArea: {
      width: "400px",
      "& dd": {
        paddingTop: "9px",
      },
    },
    datePickerAreaDaily: {
      width: "400px",
      marginRight: "-211px",
      "& dd": {
        paddingTop: "9px",
      },
    },
    datePicker: {
      width: "47%",
      margin: "0",
      "& .MuiInput-root": {
        border: "1px solid rgba(0, 0, 0, 0.23)",
        borderRadius: "4px",
        height: "30px",
        overflow: "hidden",
        padding: "5px",
      },
      "& .MuiInput-root:before": { display: "none" },
      "& .MuiInput-root:after": { display: "none" },
      "&:hover .MuiInput-root": {
        border: "1px solid rgba(0, 0, 0, 0.87)",
      },
      "& .MuiInput-root.Mui-focused": {
        border: "2px solid #3D899F",
      },
      "& .Mui-error": {
        borderColor: "#f44336",
      },
      "& .Mui-error.MuiInputBase-root": {
        borderColor: "#f44336",
      },
      "& .Mui-error.MuiInput-root.Mui-focused": {
        borderColor: "#f44336",
      },
    },
    datePickerInterval: {
      position: "absolute",
      top: "20px",
      left: "50%",
      marginTop: "4px",
      marginLeft: "-4px",
      borderTop: "1px solid #000",
      width: "5px",
      display: "block",
    },
    advancedHideFlg: {
      display: "none",
    },
    jobDd: {
      width: "100px",
    },
    technicianCodeDd: {
      width: "250px",
    },
    modelNoDd: {
      width: "150px",
    },
    customerNmDd: {
      width: "150px",
    },
    emailDd: {
      width: "200px",
    },
    technicianDd: {
      width: "150px",
    },
    autoComplete: {
      padding: "0px",
      width: "140px",
      "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']": {
        padding: "0px",
      },
      "& .MuiFormControl-marginNormal": {
        marginTop: "0px",
        marginBottom: "0px",
      },
      "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] .MuiAutocomplete-input:first-child":
        {
          padding: "0px",
          paddingLeft: "5px",
        },
      "& .MuiFormHelperText-contained": {
        marginLeft: 0,
        marginRight: 0,
      },
    },
  })
);
